import { render, staticRenderFns } from "./PopupMapObject.vue?vue&type=template&id=0b18a7a9&scoped=true"
import script from "./PopupMapObject.vue?vue&type=script&lang=js"
export * from "./PopupMapObject.vue?vue&type=script&lang=js"
import style0 from "./PopupMapObject.vue?vue&type=style&index=0&id=0b18a7a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b18a7a9",
  null
  
)

export default component.exports